/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>host.routes.ts</name>
///
/// <description>
///
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>15 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Sep16 MM  1.0.0000         First cut
/// 10Nov16  RM  1.0.0000         Change to exportable module
/// 01Dec16 YH                   Task 9542:Revamp Hydrogen Portal left hand side vertical tabs to load only when the user clicks the tab
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------

import { NgModule } from '@angular/core';
import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './authentication/login/login.component';
import { AzureADAuthLogoutComponent } from './authentication/azure-active-directory/azure-ad-auth-logout/azure-ad-auth-logout.component';
import { AzureADAuthReplyComponent } from './authentication/azure-active-directory/azure-ad-auth-reply/azure-ad-auth-reply.component';

import { CustomerContainerComponent } from './containers/customer/customer-container.component'; //YH 12/1/2016 Task 9542
import { CrestronContainerComponent } from './containers/crestron/crestron-container.component'; //YH 12/1/2016 Task 9542


import { AuthGuardFileUploadTab, AuthGuardSettingsTab, AuthGuardAccountsTab, AuthGuardUsersTab, AuthGuardCrestronUsersTab, AuthGuardCrestronDevicesTab, AuthGuardPortalManagementTab } from './authorization/shared/authguard.service';


import { CUIEmptyComponent } from './shared/cui-empty/cui-empty.component';
//YH 1/16/2017 Implement user logged in guard
import {LoggedInGuard} from './authentication/login/loggedin-guard.service';

import { TranslatedStringsResolver } from './services/language.service';


import { BaseMenuComponent } from './features/base-component/base-menu/base-menu.component';
import { BaseDetailComponent } from './features/base-component/base-detail/base-detail.component';

import { PowerBiReportContainerComponent } from './features/dashboard/powerbi-report-container/powerbi-report-container.component';
import { WorldViewContainerComponent } from './features/dashboard/world-view-container/world-view-container.component';

const appRoutes: Routes = [
  { path: '', component: LoginComponent, data: { feature: 'login' } },
  { path: 'login', component: LoginComponent, data: { feature: 'login' } },
  { path: 'logout', component: AzureADAuthLogoutComponent, data: { feature: 'logout' } },
  { path: 'aadloginreply.html', component: AzureADAuthReplyComponent, resolve: { i18n: TranslatedStringsResolver }, data: { feature: 'login-reply' } },

  { path: 'none', component: CUIEmptyComponent },

  //YH 12/1/2016 Task 9542
  {
    path: 'customer', component: CustomerContainerComponent, canActivate: [LoggedInGuard], canActivateChild: [LoggedInGuard],
    resolve: { i18n: TranslatedStringsResolver },
    children: [
      {
        path: 'customer',
        component: PowerBiReportContainerComponent,//WorldViewContainerComponent
        outlet: 'details'
      },
      {
        path: 'customer/:customerId',
        component: PowerBiReportContainerComponent,//WorldViewContainerComponent
        outlet: 'details'
      }, 
      { path: 'none', component: CUIEmptyComponent, outlet: 'list' }
    ]
  }, 
  {
    path: 'crestron', component: CrestronContainerComponent, canActivate: [LoggedInGuard], canActivateChild: [LoggedInGuard],
    resolve: { i18n: TranslatedStringsResolver },
    children: [ 
        {
          path: 'customer',
          component: PowerBiReportContainerComponent,//WorldViewContainerComponent
          outlet: 'details'
        },
        {
            path: 'customer/:customerId',
            component: PowerBiReportContainerComponent,//WorldViewContainerComponent
            outlet: 'details'
        }, 
      { path: 'none', component: CUIEmptyComponent, outlet: 'list' }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {enableTracing: false} )],
  exports: [RouterModule],
  providers: [AuthGuardAccountsTab, AuthGuardUsersTab, AuthGuardCrestronUsersTab, AuthGuardCrestronDevicesTab, TranslatedStringsResolver, AuthGuardSettingsTab, AuthGuardPortalManagementTab, AuthGuardFileUploadTab ]
})
export class RoutingModule { }



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/host.routes.ts